export function getAnvilCanvasId(widgetId: string): string {
  return `anvil-canvas-${widgetId}`;
}
